import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import differenceInSeconds from "date-fns/differenceInSeconds";

// AWS
import { API, Storage, Auth } from "aws-amplify";

function useBroadCastId({ broadCastId }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async (options = { isLoading: true }) => {
    try {
      setLoading(options.isLoading);
      const data = await API.get("MoneyHubAdmin", `/broadcast/${broadCastId}`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(data.body);
      setData(parseData.Item);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    data,
    setData,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useBroadCastId;
